import { apiClient } from '@/services/ApiClient.js'

export class CropService {
  static getCrops(query) {
    return apiClient
      .get('crops', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getApplicableCrops(regionId, cityId) {
    return apiClient
      .get('applicable-crops/?regionId=' + regionId + '&cityId=' + cityId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getCrop(cropId) {
    return apiClient
      .get('crops/' + cropId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static createCrop(params) {
    return apiClient
      .post('crops', params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static updateCrop(cropId, crop) {
    return apiClient
      .patch('crops/' + cropId, crop)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static deleteCrop(cropId) {
    return apiClient
      .delete('crops/' + cropId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
